import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';
import prepareDynamicBlock from '~/helpers/prepareDynamicBlock';
import { sectionsWithDataProps } from '@webplatform/asbis-ui/dist/sections';

interface Props {
  blocks: Array<Object>;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PageBlocks',
  props: {
    blocks: null
  },
  setup(__props: any) {

const props = __props as {
  blocks: Array<Object>;
};

const pascalToKebab = (string: string) =>
  string.replace(/([a-z0–9])([A-Z])/g, '$1-$2').toLowerCase();

const AB_COMPONENTS_WITH_DATA_PROPS = sectionsWithDataProps.map(
  (component: string) => pascalToKebab(component),
);

const CANYON_NO_DATA_BINDING_COMPONENTS = [
  'about-cards',
  'about-gaming',
  'about-header',
  'about-image',
  'about-text',
  'app-promotions',
  'category-banner-large',
  'category-banner-small',
  'category-banner-small-group',
  'category-cards-section',
  'form-section',
  'main-slider',
  'news-section',
  'product-characteristics',
  'prose-block',
  'rich-advantages',
  'rich-advantages-list',
  'rich-footer',
  'rich-header',
  'rich-images-grid',
  'rich-video',
  'rich-advantages',
  'seo-text',
  'tips-section',
  'user-help-cards',
  ...AB_COMPONENTS_WITH_DATA_PROPS,
];



const components = computed(() =>
  props.blocks?.map((block) => prepareDynamicBlock(block)),
);

const getComponentAttrs = (component: any) => {
  const data = component?.data;

  if (CANYON_NO_DATA_BINDING_COMPONENTS.includes(component?.type))
    return { data };

  return data;
};

return { __sfc: true,pascalToKebab, AB_COMPONENTS_WITH_DATA_PROPS, CANYON_NO_DATA_BINDING_COMPONENTS, props, components, getComponentAttrs }
}

})